import { StarDef } from '../BodyDef';

/**
 * Cyrene: a slightly hotter, slightly more massive G-type star.
 *
 * Its surface gravity entry is what the mass model is derived from, so the
 * value is chosen to yield ~2.09e30 kg (about 1.05 solar masses):
 *   M = g * R^2 / G  with  R = 7.24e8 m
 */
export const CYRENE: StarDef = {
  id: 'cyrene',
  name: 'Cyrene',
  kind: 'star',
  parentId: null,
  radius: 7.24e8,
  surfaceGravity: 265.9,
  rotationPeriod: 25.1 * 86400,
  axialTilt: 0,
  epochSpin: 0,
  orbit: null,
  surfaceClass: 'none',
  explorable: false,
  atmosphere: null,
  temperature: 5910,
  luminosity: 4.2e26,
  color: [1.0, 0.945, 0.86],
  thermal: {
    meanSurfaceTemperature: 5910,
    polarDelta: 0,
    diurnalRange: 0,
    lapseRate: 0,
  },
  hazards: {
    radiation: 1e6,
    stormFrequency: 1,
    seismicActivity: 0,
    corrosion: 0,
    notes: ['Lethal radiation and thermal flux within 0.1 AU.', 'Coronal mass ejections disrupt navigation and trade.'],
  },
  terrain: null,
  palette: {
    deepWater: [0, 0, 0],
    shallowWater: [0, 0, 0],
    shore: [0, 0, 0],
    lowland: [1, 0.9, 0.7],
    midland: [1, 0.9, 0.7],
    highland: [1, 0.95, 0.8],
    peak: [1, 1, 0.95],
    nightEmissive: [1, 0.92, 0.8],
    nightEmissiveStrength: 1,
  },
  biomes: [],
  settlementDensity: 0,
  lifePotential: 0,
  description:
    'A G2-class star, marginally brighter than Sol. Its habitable band sits between 0.9 and 1.5 AU, and its ' +
    'eleven-year magnetic cycle drives the storm seasons that periodically close inner-system trade lanes.',
  markerColor: [1, 0.92, 0.7],
};
